export type AvailableFilter = ToggleFilterType | GroupFilter;

export type ToggleFilterType = {
  count: number;
  filterIcon?: string | null;
  label: string;
  labelIcon?: string | null;
  name: string;
  showCount: boolean;
  sortOrder: number;
  sublabel?: string | null;
  type: string;
};

export type GroupFilterValue = {
  badge: string | null;
  chip: string;
  count: number;
  label: string;
  sortOrder: number;
  type: string;
  value: string;
};

export type GroupFilter = {
  label: string;
  name: string;
  showCount: boolean;
  sortOrder: number;
  type: string;
  values: GroupFilterValue[];
};
export enum FilterType {
  tileGroup = "tile_group",
  checkBoxGroup = "checkbox_group",
  toggle = "toggle",
}
export enum FilterName {
  DispensaryName = "dispensary_name",
  StrainCategory = "strain_category",
  StrainEffects = "strain_effects",
}
